<script setup lang="ts">
import {Smartphone} from "@lucide/vue";

defineProps<{
    phone: string;
}>();
</script>

<template>
  <div class="bg-muted p-2 border rounded-lg flex gap-2 items-center">
    <Smartphone class="text-muted-foreground" />
    <p class="font-medium">
      {{ phone }}
    </p>
  </div>
</template>

<style scoped>

</style>
